import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import { Field, reduxForm } from 'redux-form'

import './ImageExportModal.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import Checkbox from '../../components/Checkbox/Checkbox.js'

import { setImageExportModalOpen, tryToRenderPattern } from '../../actions/actions.export.js';


class ImageExportModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      image_url: undefined,
      width: 1200,
      height: 1200,
      bg_color: 'ffffff',
      line_color: '000000',
      stroke_width: 1,
      scale: 1,
    }

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleRenderPattern = this.handleRenderPattern.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    dispatch(setImageExportModalOpen());
  }

  handleRenderPattern(){
    const { dispatch, patternManager, user, team } = this.props;
    
    delete patternManager.cache[patternManager.current_pattern].temp_render;

    dispatch(tryToRenderPattern({
      pattern: patternManager.cache[patternManager.current_pattern],
      width: parseInt(this.state.width),
      height: parseInt(this.state.height),
      line_color: this.state.line_color,
      bg_color: this.state.bg_color,
      stroke_width: parseInt(this.state.stroke_width),
      scale: parseFloat(this.state.scale)
    }));  
  }


  render(){
    const { dispatch, globalReducer, user, team, patternManager } = this.props; 
    
    if(!globalReducer.imageExportModalOpen) return "";

    var pattern = patternManager.cache[patternManager.current_pattern];

    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            Export Image
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModal}/> 
          </span>
        </div>
        <hr/>
        <div className="image-export-modal">
          <div className="image-export-preview-wrapper">
            <div className="image-export-preview" style={{
              backgroundImage: 'url(' + pattern.temp_render + ')'
            }}>
              {
                !pattern.temp_render && <div className="image-export-preview-placeholder">
                  Configure settings and click Render to generate an image.
                </div>
              }
            </div>
          </div>
          <div className="image-export-modal-info">
            <div className="image-export-modal-nontable">
              <div className="flex-split">
                <span>
                  Width:
                </span>
                <span className="text-right">
                  <Field 
                    name="width" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="number" 
                    onChange={(e) => { this.setState({width: e.target.value}) }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Height:
                </span>
                <span className="text-right">
                  <Field 
                    name="height" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="number" 
                    onChange={(e) => { this.setState({height: e.target.value}) }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Lines:
                </span>
                <span className="text-right  image-export-hex-field">
                  <Field 
                    name="line_color" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="text" 
                    onChange={(e) => { this.setState({line_color: e.target.value}) }}
                    />
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Background:
                </span>
                <span className="text-right image-export-hex-field">
                  <Field 
                    name="bg_color" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="text" 
                    onChange={(e) => { this.setState({bg_color: e.target.value}) }}
                    />
                </span>
              </div>


              <div className="flex-split">
                <span>
                  Stroke Width:
                </span>
                <span className="text-right">
                  <Field 
                    name="stroke_width" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="number" 
                    onChange={(e) => { this.setState({stroke_width: e.target.value}) }}
                    />
                </span>
              </div>


              <div className="flex-split">
                <span>
                  Scale:
                </span>
                <span className="text-right">
                  <Field 
                    name="scale" 
                    disabled={patternManager.tryingToRenderPattern}
                    component="input" 
                    type="number" 
                    step={.1}
                    min={.1}
                    max={20}
                    onChange={(e) => { this.setState({scale: e.target.value}) }}
                    />
                </span>
              </div>

            </div>

            <div className="image-export-button-wrapper">
              <Button
                display={
                  pattern.temp_render ?
                  <span><i className="fad fa-sync-alt fa-swap-opacity"/>&nbsp; Rerender</span>
                  :
                  <span><i className="fad fa-camera fa-swap-opacity"/>&nbsp; Render</span>
                }
                color={pattern.temp_render ? "grey" : "success"}
                size="medium"
                thinking={patternManager.tryingToRenderPattern}
                onClick={this.handleRenderPattern}
                />
              <a href={pattern.temp_render}  download={pattern.name + ".png"} className={"button-link " + (pattern.temp_render ? "" : "disabled")}>
                <Button
                  display={<span><i className="fad fa-download fa-swap-opacity"/>&nbsp; Download Image</span>}
                  color={pattern.temp_render ? "success" : "grey"}
                  size="medium"
                  disabled={!pattern.temp_render}
                  />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
    
  }
}

ImageExportModal = reduxForm({
  // a unique name for the form
  form: 'ImageExportModal',
  enableReinitialize: true,
  destroyOnUnmount: false
})(ImageExportModal)


ImageExportModal = connect((state, ownProps) => {
  const { patternManager, globalReducer } = state;

  var initialValues = {
    width: 1200,
    height: 1200,
    bg_color: 'ffffff',
    line_color: '000000',
    stroke_width: 1,
    scale: 1
  }

  return {
    patternManager,
    globalReducer,
    initialValues,
    state
  }
})(ImageExportModal);


export default ImageExportModal;



// WEBPACK FOOTER //
// ./src/components/ImageExportModal/ImageExportModal.js